'use client'

import { ChangeEvent } from 'react'
import { Cell, Toggle } from '@vinted/web-ui'

import { useTranslate } from '@marketplace-web/i18n/i18n-feature'

type Props = {
  isChecked: boolean
  isDisabled: boolean
  onChange: (isChecked: boolean) => void
}

const BundleDiscountsToggle = ({ onChange, isChecked, isDisabled }: Props) => {
  const translate = useTranslate('settings.bundle_discounts')
  const toggleTitleId = 'toggle-title-enable-bundle-discounts'

  function handleOnChange({ target }: ChangeEvent<HTMLInputElement>) {
    onChange(target.checked)
  }

  return (
    <Cell
      id={toggleTitleId}
      title={translate('settings_title')}
      suffix={
        <Toggle
          name="bundle-discounts-toggle"
          testId="bundle-discounts-toggle"
          checked={isChecked}
          disabled={isDisabled}
          onChange={handleOnChange}
          aria={{
            'aria-labelledby': toggleTitleId,
          }}
        />
      }
      styling="wide"
    />
  )
}

export default BundleDiscountsToggle
